import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { CurrencyModel } from '../models/currency.model';
import { InfraService } from './infra.service';

@Injectable()
export class CurrencyService {
    private configUrl :string;
    private coreAPIUrl: string;

  constructor(private infraService: InfraService, private http: HttpClient) {

    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'currency';
      this.coreAPIUrl = data.WebEndPoint2 + 'Currency';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

    }

    public getAllCurrencies(): Observable<CurrencyModel[]> {
        return this.http.get<CurrencyModel[]>(`${this.coreAPIUrl}/GetCurrencies`);
        // .catch(this.handleError);
    }


    private handleError(error: Response) {
      return throwError(()=> error);
    }
}
